import { render, staticRenderFns } from "./StarBarChart.vue?vue&type=template&id=355c02e5&"
import script from "./StarBarChart.vue?vue&type=script&lang=js&"
export * from "./StarBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports